export default __webpack_public_path__ + "static/media/graduation-smaller.77329547.jpg";